<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>关于少儿之家园点端</h1>
      </div>
      <div class="liner"></div>
    </div>



    <div class="main-page">
      <div class="about-app">
        <div class="text-center margin-15 padding-15">
          <img :src="logo_yd" width="100" height="100" style="margin:0 auto">
          <span class="padding-15 block">少儿之家园点端 v2.0</span>
        </div>
        <div class="bg-white padding-15">
          <p>托管教育园点招生管理神器</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      logo_yd: require('../../../assets/images/logo-yd.png')
    }
  },
  mounted: function () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// About.vue?0c1d2981